export const DEGENCHAIN = {
  chainId: 666666666,
  chainName: "DEGENCHAIN",
  isTestChain: false,
  isLocalChain: false,
  multicallAddress: "0x0000000000000000000000000000000000000000",
  getExplorerAddressLink: (address) =>
    `https://explorer.degen.tips/address/${address}`,
  getExplorerTransactionLink: (transactionHash) =>
    `https://explorer.degen.tips/tx/${transactionHash}`,
  rpcUrl: "https://rpc.degen.tips",
  blockExplorerUrl: "https://explorer.degen.tips/",
  nativeCurrency: {
    name: "DEGEN",
    symbol: "DEGEN",
    decimals: 18,
  },
};
